var map = {
	"./error-page.webp": 2417,
	"./maintenance.webp": 2418,
	"./miscellaneous-bg.webp": 2419,
	"./miscellaneous-mobile-bg.webp": 2420,
	"./restriction.webp": 2421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 488;